var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 17.5004H19.3499L19.9499 5.30039C19.9999 4.10039 19.5999 2.95039 18.7999 2.10039C17.9999 1.30039 17.0499 0.900391 15.9999 0.900391C14.9499 0.900391 13.9499 1.35039 13.1999 2.10039C12.3999 2.95039 11.9499 4.10039 11.9999 5.30039L12.6499 17.5004H8.9999C5.8999 17.5004 3.3999 20.2004 3.3999 23.5504V25.9004C3.3999 26.6504 3.9499 27.2504 4.6499 27.3004V28.0004C4.6499 29.7004 6.0499 31.1504 7.7999 31.1504H24.1499C25.8499 31.1504 27.2999 29.7504 27.2999 28.0004V27.3004C27.9999 27.2504 28.5499 26.6504 28.5499 25.9004V23.5504C28.5499 20.2004 26.0499 17.5004 22.9999 17.5004ZM14.2999 5.20039C14.2499 4.60039 14.4999 4.05039 14.8499 3.65039C15.4999 3.00039 16.4999 3.00039 17.1499 3.65039C17.5499 4.05039 17.7499 4.60039 17.6999 5.15039L17.0999 17.5004H14.8999L14.2999 5.20039ZM5.6999 23.5504C5.6999 21.4504 7.1999 19.7504 9.0499 19.7504H12.7999H19.2499H22.9999C24.8499 19.7504 26.3499 21.4504 26.3499 23.5504V25.1004H5.6999V23.5504ZM24.1999 28.9004H7.7999C7.2999 28.9004 6.8999 28.5004 6.8999 28.0004V27.3504H24.9999V28.0004C25.0499 28.5004 24.6499 28.9004 24.1999 28.9004Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStamp);
export default __webpack_public_path__ + "static/media/emptyStamp.40861916e57b60aa2370a1dab5a366e4.svg";
export { ForwardRef as ReactComponent };